function initPdpGallery() {
  // Video Overlay
  document.querySelectorAll('[data-video-wrapper]').forEach((wrapper) => {
  if (wrapper._pdpVideoInit) return;
  wrapper._pdpVideoInit = true;

  const btn = wrapper.querySelector('[data-video-toggle]');
  const video = wrapper.querySelector('.pdp-video-overlay__video');
  const playIcon = wrapper.querySelector('.pdp-video-icon--play');
  const pauseIcon = wrapper.querySelector('.pdp-video-icon--pause');

  if (!btn || !video) return;

  btn.addEventListener('click', () => {
    const isPlaying = btn.getAttribute('aria-pressed') === 'true';
    if (isPlaying) {
      video.pause();
      video.classList.remove('is-playing');
      btn.setAttribute('aria-pressed', 'false');
      playIcon.style.display = '';
      pauseIcon.style.display = 'none';
    } else {
      if (!video.src && video.dataset.src) video.src = video.dataset.src;
      video.play();
      video.classList.add('is-playing');
      btn.setAttribute('aria-pressed', 'true');
      playIcon.style.display = 'none';
      pauseIcon.style.display = '';
    }
  });

  // Video schließen bei Klick außerhalb
  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      video.pause();
      video.classList.remove('is-playing');
      btn.setAttribute('aria-pressed', 'false');
      playIcon.style.display = '';
      pauseIcon.style.display = 'none';
    }
  });
});

  // Split Gallery - Variant Image Switcher
  document.querySelectorAll('[data-split-right]').forEach((container) => {
    if (container._pdpSplitInit) return;
    container._pdpSplitInit = true;

    const scriptTag = document.querySelector('script[id^="pdp-variant-images"]');
    if (!scriptTag) return;

    let variantImages = {};
    try {
      variantImages = JSON.parse(scriptTag.textContent);
    } catch (e) {
      return;
    }

    function setImage(variantId) {
      if (!variantId || !variantImages[variantId]) return;
      let img = container.querySelector('[data-split-right-img]');
      if (!img) {
        img = document.createElement('img');
        img.setAttribute('data-split-right-img', '');
        img.className = 'pdp-split-gallery__right-image';
        container.appendChild(img);
      }
      img.src = variantImages[variantId];
    }

    // Initial
    const initialId = document.querySelector('[name="id"]')?.value;
    setImage(initialId);

    // Bei Variantenwechsel
    document.addEventListener('variant:change', (e) => {
      setImage(String(e.detail?.variant?.id));
    });
  });
}

document.addEventListener('DOMContentLoaded', initPdpGallery);

// Re-init nach Theme/Variant DOM-Updates
const observer = new MutationObserver(() => initPdpGallery());
observer.observe(document.body, { childList: true, subtree: true });
